import { FC, useState } from "react";
import CardCustom from "../../components/card";
import TitleValue from "../../components/title-value";
import CardBasicCustom from "../../components/card-basic";
import "./home.css";
import ChartCustom, { DataChart } from "../../components/chart";
import useFetchStatistics from "../../service/userStatistics/getStatistic";
import {
  faChartSimple,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
import { CardBasicCustomProps } from "../../model/custom-card-basic";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from "@mui/material";
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { formatearPesoMXN } from "../../utilis/formatter";
import useFetchMonthStatistics from "../../service/userStatistics/getMonthStatistics";
import TransactionsMonthlyChart from "../../components/charts/transactionsMonthly";
import { InputDatePicker } from "../../components/inputsDatePicker/inputDatePicker";

const Home: FC = () => {
  const storedToken = sessionStorage.getItem("userData");

  const { statistics, loading, error } = useFetchStatistics(storedToken || "");

  const { monthStatistics } = useFetchMonthStatistics(storedToken || "");

  const [startDateTransactions, setStartDateTransactions] = useState<Date | null>(null);
  const [endDateTransactions, setEndDateTransactions] = useState<Date | null>(null);

  const handleClearTransactionsFilters = () => {
      setStartDateTransactions(null);
      setEndDateTransactions(null);
    };


  const dataCard: CardBasicCustomProps[] = [
    {
      icon: faChartSimple,
      iconTooltip: <InfoIcon />,
      titleTooltip:
        "Este valor representa el monto total de las transacciones aprobadas durante mes. Indica cuánto se ha cargado exitosamente a las tarjetas de tus clientes.",
      value:
        formatearPesoMXN(
          statistics?.response[0]?.currentMonth[0]
            ?.total_transaccion_current_month_without_comission
            ? statistics?.response[0]?.currentMonth[0]
                ?.total_transaccion_current_month_without_comission
            : 0
        ) || formatearPesoMXN(0),
      description: "Total de cargos aprobados en el mes actual",
      classCustom: "card-first",
    },

    {
      icon: faChartSimple,
      iconTooltip: <InfoIcon />,
      titleTooltip:
        "Este valor representa el monto total de las transacciones aprobadas durante mes pasado. Indica cuánto se ha cargado exitosamente a las tarjetas de tus clientes.",
      value:
        formatearPesoMXN(
          statistics?.response[0]?.lastMonth[0]
            ?.total_transaccion_last_month_without_comission
            ? statistics?.response[0]?.lastMonth[0]
                ?.total_transaccion_last_month_without_comission
            : 0
        ) || formatearPesoMXN(0),
      description: "Total de cargos aprobados en el mes anterior",
      classCustom: "card-first",
    },
    // {
    //   icon: faFileContract,
    //   iconTooltip: faChartSimple,

    //   value: "$0",
    //   description: "Monto retenido",
    //   classCustom: "card-second",
    // },
    // {
    //   icon: faChartSimple,
    //   iconTooltip: <InfoIcon/>,
    //   titleTooltip: 'Este valor refleja la cantidad total de transacciones que han sido rechazadas o canceladas. Las razones comunes incluyen fondos insuficientes, problemas con la tarjeta o cancelaciones manuales por parte del cliente o del sistema.',
    //   value: `$${!totalCanceledAmount ? 0 : totalCanceledAmount.toLocaleString('es-MX')}`,
    //   description: "Montos rechazados",
    //   classCustom: "card-third",
    // },
    // {
    //   icon: faChartSimple,
    //   value: `${newCustomers}`,
    //   description: "Nuevos Clientes",
    //   classCustom: "card-fourth",
    // },
  ];

  return (
    <div className="home">
      <div className="section1">
        <CardCustom>
          {/* <TitleValue title="Cargos totales" value={totalAmount.toLocaleString('es-MX')} /> */}
          <div className="cards_home">
            {dataCard.map((card, index) => (
              <CardBasicCustom
                key={card.description}
                iconTooltip={card.iconTooltip}
                titleTooltip={card.titleTooltip}
                icon={card.icon}
                value={card.value}
                description={card.description}
                info={card.info}
            
                classCustom={card.classCustom}
              />
            ))}
          </div>
        </CardCustom>
      </div>
      <div className="graphics_home">
        <CardCustom classCustom="card_chart_bar">
          <div className="home-chart-filters">
              <InputDatePicker
                startDate={startDateTransactions}
                setStartDate={setStartDateTransactions}
                endDate={endDateTransactions}
                setEndDate={setEndDateTransactions}
              />
              <IconButton
                onClick={handleClearTransactionsFilters}
                color="primary"
                sx={{
                  border: '1px solid #1976d2',
                  borderRadius: '8px',
                  padding: '8px',
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  },
                }}
                title="Limpiar filtros"
              >
                <CleaningServicesIcon />
              </IconButton>
          </div>
          <TransactionsMonthlyChart 
            data={monthStatistics?.response || []} 
            startDate={startDateTransactions} 
            endDate={endDateTransactions} 
          />
        </CardCustom>
      </div>
    </div>
  );
};

export default Home;
